// data and config constants
const DATA = {};
const CONFIG = {};

// file imports
import icons from './icons.js'; 
import MapboxDirections from '../static/libs/mapbox-gl-directions';

// MB access token
CONFIG.access_token = 'pk.eyJ1IjoidG9tLWlsaW5lLTIxIiwiYSI6ImNrbDJlOWh2NjBjNnoyd21yamk2eGd0YWEifQ.F5N02JRotHmPJZjWu7jeDw';

// map defaults
CONFIG.startlat = 44.47512;
CONFIG.startlon = -73.21964;
CONFIG.startzoom = 15;
CONFIG.startpitch = 0;
CONFIG.startbearing = 0;

// import styles from './index.scss';
import './index.scss';

///////////////////////////////////////////////////////////////////////////////////////////////////////////
///// INITIALIZATION: these functions are called when the page is ready,
///////////////////////////////////////////////////////////////////////////////////////////////////////////
document.addEventListener('DOMContentLoaded', function (event) {
  initData().then(function () {
    // init data, then
    initDataFormat(); // data formatting and other data tasks
    initMap(); // map inits
    initFooter(); // init the image slider in the footer
    initDirections(); // init the directions buttons and cetera

    // start things off by opening a modal
    initStartupModal();
  })
})

///////////////////////////////////////////////////////////////////////////////////////////////////////////
// Functions called on doc ready
///////////////////////////////////////////////////////////////////////////////////////////////////////////
function initData() {
  // fetch the CSV data then process it with Papa parse
  // returns a promise so we can wait for it to resolve, then move onto the rest of the init steps
  return new Promise(function (resolve, reject) {
    fetch('./data/data.csv')
      .then(function (response) {
        // parse from datastream to text
        return response.text();
      })
      .then(function (data) {
        // `data` is the parsed version of the JSON returned from the above endpoint.
        let rawdata = Papa.parse(data, {
          header: true,
          skipEmptyLines: 'greedy',
        })

        // keep a reference
        DATA.poi_data = rawdata.data;

        // phew!
        resolve();
      })
  }) // promise
}

function initDataFormat() {
  // pull out the access points, for convenience
  DATA.access_points = DATA.poi_data.filter(function (d) {
    return d.poi_type == 'access';
  })
  // console.log(DATA);
}

function initStartupModal() {
  // show the modal (one time), and configure as we do so
  MicroModal.show('modal-splash', {
    awaitCloseAnimation: true,
    onClose: function (modal, element, event) {
      event.preventDefault();
      event.stopPropagation();
    },
  })
}

function initMap() {
  mapboxgl.accessToken = CONFIG.access_token;

  CONFIG.map = new mapboxgl.Map({
    container: 'map',
    style: 'mapbox://styles/tom-iline-21/ckl9rykrb17wl17nxyufm1fss',
    center: { lon: CONFIG.startlon, lat: CONFIG.startlat },
    zoom: CONFIG.startzoom,
    pitch: CONFIG.startpitch, // pitch in degrees
    bearing: CONFIG.startbearing, // bearing in degrees. 0 for due north, -180 for due south
  })

  // Add zoom and rotation controls to the map.
  CONFIG.map.addControl(new mapboxgl.NavigationControl());

  // Add geolocate control to the map.
  CONFIG.geolocation = new mapboxgl.GeolocateControl({
    positionOptions: {
      enableHighAccuracy: true,
    },
    trackUserLocation: true,
  })

  CONFIG.map.addControl(CONFIG.geolocation);

  // MB provides very few hooks to know if the control is active and we have a position. This is one.
  // The problem is that, if a user turns off the control, presumably they don't want to be tracked (even though they still will be, since they already gave permission)
  // So, before routing using user_lat and user_long, make sure that they are present AND
  // CONFIG.geolocation_watchState != "OFF"  - yes that's an internal variable, but it's all we got
  // note: OFF is used both for the inactive button state, and also when geolocation is blocked
  CONFIG.geolocation.on('geolocate', function (position) {
    CONFIG.user_latitude = position.coords.latitude;
    CONFIG.user_longitude = position.coords.longitude;
  })

  // Add and configure MapboxDirections Controls to the map: one for bike, one for walk
  // we actually hide all of the controls, and use only the internals to show a route on the map
  CONFIG.directions = new MapboxDirections({
    accessToken: CONFIG.access_token,
    interactive: false, // if true, then clicks on the map set the origin and destination
    // default to cycling
    profile: 'mapbox/cycling',
    controls: {
      inputs: false,
      profileSwitcher: false,
      instructions: false,
    },
  })
  // add it to the map
  CONFIG.map.addControl(CONFIG.directions);

  // add the POI markers to the map
  DATA.poi_data.forEach(function (d) {
    // the map icons are made up of two background svgs: one icon (downloaded from font awesome pro), and a map pin (from fa-map-marker)
    // in static/icons we have a set of markers and icons to draw from
    // data.csv tells us which fa-icon to use, and what color for the marker
    let icon = '';
    if (d.icon === '') {
      icon = 'marker-grey';
    } else if (d.icon === 'trail-access') {
      icon = 'trail_access';
    } else {
      icon = d.icon;
    }

    let marker = '';
    if (d.iconcolor === '') {
      marker = 'marker-grey';
    } else if (d.icon === 'none') {
      marker = '';
    } else {
      marker = `marker-${d.iconcolor}`;
    }

    // set the icontop to 10px, adjust if needed from the data.csv
    let topadjust = d.icontop ? parseInt(d.icontop) : 0;
    let icontop = 10 + topadjust;

    // set the iconleft to 8px, adjust if needed from the data.csv
    let leftadjust = d.iconleft ? parseInt(d.iconleft) : 0;
    let iconleft = 8 + leftadjust;

    // set the iconsize to 14px or override if called for from the data.csv
    let iconsize = d.iconsize || 14;

    // create a DOM element for the marker
    let el = document.createElement('div');
    el.className = 'marker';

    if (marker === 'marker-none') {
    	// these have only a single background image 
    	el.style.backgroundImage = `url(${icons[icon]})`;
      el.style.backgroundSize = `${iconsize}px, 30px`;
      el.style.backgroundRepeat = 'no-repeat';
      el.style.backgroundPosition = `top ${icontop}px left ${iconleft}px, center`;
    } else {
	    el.style.backgroundImage = `url(${icons[icon]}), url(${icons[marker]}), url(${icons['shadow']})`;
      el.style.backgroundSize = `${iconsize}px, 30px, 45px`;
      el.style.backgroundRepeat = 'no-repeat, no-repeat, no-repeat';
      el.style.backgroundPosition = `top ${icontop}px left ${iconleft + 9}px, center center, left 9px bottom 0px`;
    }
    el.style.width = '47px';
    el.style.height = '40px';
    el.style.zIndex = 1; // above the "error halo" of your position, but below the map controls, and the popups
    el.dataset.name = d.name;
    el.dataset.icon = icon;

    // set the popup content
    let html = '';
    switch (d.poi_type) {
      case 'access':
        // no links for these, just a name
        html = `<h3 class="popup-header access-header">${d.name}</h3>`;
        // then the description
        html += `<div class="description">${d.description}</div>`;
        // add a footer wrapper
        html += '<div id=popup-footer>';
        // add a button for directions
        html += `<a class="btn popup-footer-directions" role="button" href="javascript:void(0);" data-lat="${d.latitude}" data-lng="${d.longitude}" data-name="${d.name}" target="blank">Get directions</a>`;
        html += '</div>';

        break;

      default:
        if (d.url) {
          html = `<a class="header-link" href="${d.url}" target="_blank">`;
          html += `<h3 class="popup-header">${d.name}`;
          html += '<span class="outlink"></span></h3>';
          html += '</a>';
        } else {
          html = `<h3 class="popup-header">${d.name}`;
        }

        // then the description
        html += `<div class="description">${d.description}</div>`;

        // add a footer wrapper
        html += '<div id=popup-footer>';
        // repeat the website URL at the bottom
        if (d.url) html += `<a class="popup-footer-website-link" href="${d.url}" target="blank">Visit website</a>`;
        // add a button for directions
        html += `<a class="btn popup-footer-directions" role="button" href="javascript:void(0);" data-lat="${d.latitude}" data-lng="${d.longitude}" data-name="${d.name}" target="blank">Get directions</a>`;
        html += '</div>';
    }
    // add the HTML to the popup
    var popup = new mapboxgl.Popup().setHTML(html);

    // add the marker to map
    const glmarker = new mapboxgl.Marker(el)
      .setLngLat([d.longitude, d.latitude])
      .setPopup(popup)
      .addTo(CONFIG.map);

    // add some additional event tracking to the marker
    glmarker.getElement().addEventListener('click', (e) => {
        let data_name = e.target.dataset.name;
        let data_icon = e.target.dataset.icon;

        // register an analytics event
        ga('send', 'event', `Clicked POI icon ${data_icon}`, `Name: ${data_name}`);

    });
  })

  // create a zoom home control
  class zoomHomeControl {
    onAdd(map) {
      this.map = map;

      // create a container for the button, with mapbox-gl classes
      this.container = document.createElement('div');
      this.container.classList.add('mapboxgl-ctrl');
      this.container.classList.add('mapboxgl-ctrl-group');

      // add an inner button, with an icon
      let button = document.createElement('button');
      button.className = 'zoom-home-control';
      button.innerHTML =
        '<span class="zoom-home-icon mapboxgl-ctrl-icon"></span>';

      // join the two pieces
      this.container.innerHTML = button.outerHTML;

      // register a click event on the button
      this.container.addEventListener('click', function () {
        map.flyTo({
          center: [CONFIG.startlon, CONFIG.startlat],
          zoom: CONFIG.startzoom,
          bearing: CONFIG.startbearing,
          pitch: CONFIG.startpitch,
        });
      });

      // all set
      return this.container;
    }
    onRemove() {
      this.container.parentNode.removeChild(this.container);
      this.map = undefined;
    }
  }

  // add the zoom home control we just created, above
  CONFIG.map.addControl(new zoomHomeControl())
}

// footer is a rotating gallery of ads
function initFooter() {
  // first, randomly shuffle the slides, so they load in different order "every" time
  var slides = document.querySelector('div.swiper-wrapper');
  for (var i = slides.children.length; i >= 0; i--) {
    slides.appendChild(slides.children[Math.random() * i | 0]);
  }

  // init the carousel itself. Markup of images is directly in index.html
  new Swiper('.swiper-container', {
    loop: true,
    autoplay: {
      delay: 10000,
      disableOnInteraction: false,
    },
    centeredSlides: true,
    grabCursor: true,
  });

  // track image clicks in a gtag event
  document.querySelectorAll('.slide-link').forEach(slide => 
      slide.addEventListener('click', (e) => {
        let data_client = e.currentTarget.dataset.client;
        // register an analytics event
        ga('send', 'event', `Clicked footer ad`, `Client: ${data_client}`);
      })
    )

}

// inits for the directions system
function initDirections() {

  // event handler for the "Get To The Trail" button
  let directions_btn = document.getElementById('directions-btn');
  directions_btn.addEventListener('click', function () {
    // find the closest access point to the users location
    let closest = { distance: Infinity }
    DATA.access_points.forEach(function (d) {
      let distance = getDistanceFromLatLng(
        CONFIG.user_latitude,
        CONFIG.user_longitude,
        d.latitude,
        d.longitude
      );
      d.distance = distance;
      if (distance < closest.distance) {
        closest = d;
      }
    })

    // call the directions/route function
    // note we're not testing here for "closest", it could be null because geo is turned off
    // but that's ok, the recipient function will handle that check
    getDirectionsAndRoute(closest);
  })


  // delegated event handler for the "GET DIRECTIONS" buttons on the map poups
  document.querySelector('#map').addEventListener('click', (e) => {
    if (!e.target.matches('.popup-footer-directions')) {
      return;
    }
    e.preventDefault();
    e.stopPropagation();
    let destination = {
      latitude: parseFloat(e.target.dataset.lat),
      longitude: parseFloat(e.target.dataset.lng),
      name: e.target.dataset.name,
    };
    // close the popup
    const popup = document.getElementsByClassName('mapboxgl-popup');
    if (popup.length) {
      popup[0].remove();
    }
    // get the route
    getDirectionsAndRoute(destination);
  })

  // init the clearlink to hide directions that are on the map
  document.getElementById('clearlink').addEventListener('click', (e) => {
    e.target.style.display = 'none';
    CONFIG.directions.removeRoutes();
  })
}

/////////////////////////////////////////////////////////////////
// NAMED FUNCTIONS
/////////////////////////////////////////////////////////////////

// use MB directions API to get directions to and from locations,
// and add a route to the map
function getDirectionsAndRoute(destination) {
  // show the clearlink
  document.getElementById('clearlink').style.display = 'block';

  // remove routes before adding any more
  CONFIG.directions.removeRoutes();
  // find the nearest trail access POI to the users location
  // CONFIG.geolocation_watchState != "OFF"  - yes that's an internal variable, but it's all we got
  // note: OFF is used both for the inactive button state, and also when geolocation is blocked
  if (CONFIG.user_latitude && CONFIG.user_longitude && CONFIG.geolocation._watchState != 'OFF') {
    CONFIG.directions.setProfile('mapbox/cycling');
    CONFIG.directions.setOrigin([CONFIG.user_longitude, CONFIG.user_latitude]);
    CONFIG.directions.setDestination([
      destination.longitude,
      destination.latitude,
    ]);

    // register an analytics event
    let data_client = destination.name;
    ga('send', 'event', `Clicked directions`, `Direction to: ${data_client}`);

  } else {
    // Geolocation not available
    document.getElementById('clearlink').style.display = 'none';
    alert(
      'Position not found. Make sure you click on the geolocation icon on the right side of the map, and allow geolocation through your browser and operating system settings.'
    );
  }
}

/*
 * SHIMS AND UTILITIES
 */

/* Distance between two lat/lng coordinates in km using the Haversine formula */
/* Copyright 2016, Chris Youderian, SimpleMaps, http://simplemaps.com/resources/location-distance
 Released under MIT license - https://opensource.org/licenses/MIT */
function getDistanceFromLatLng(lat1, lng1, lat2, lng2, miles) {
  // miles optional
  if (typeof miles === 'undefined') {
    miles = false;
  }
  function deg2rad(deg) {
    return deg * (Math.PI / 180);
  }
  function square(x) {
    return Math.pow(x, 2);
  }
  var r = 6371; // radius of the earth in km
  lat1 = deg2rad(lat1);
  lat2 = deg2rad(lat2);
  var lat_dif = lat2 - lat1;
  var lng_dif = deg2rad(lng2 - lng1);
  var a =
    square(Math.sin(lat_dif / 2)) +
    Math.cos(lat1) * Math.cos(lat2) * square(Math.sin(lng_dif / 2));
  var d = 2 * r * Math.asin(Math.sqrt(a));
  if (miles) {
    return d * 0.621371;
  } //return miles
  else {
    return d;
  } //return km
}
